import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ParameterFormatter from '../ParameterFormatter';
import MultipleNumber3RowType from './MultipleNumber3RowType';

const MultipleNumber3Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.max} /></th>
                    <td><ParameterFormatter value={question.max} /></td>
                </tr>
            </tbody>
        </table>
        <h4><FormattedMessage {...messages.surveys.form.label.rows} /></h4>
        <MultipleNumber3RowType rows={question.rows} />
    </>
);

MultipleNumber3Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default MultipleNumber3Type;
